// extracted by mini-css-extract-plugin
export default {"container":"jV0jBOnN","content":"fm3oyn1V","button":"Obk3Trkq","icon":"u1c_6MuX","info":"_c1AorlK","danger":"hpS6HHKr","success":"af5na0Tc","warning":"FFDui9w7"};